export const DEFAULT_ROOT_STYLES = {
  css: {
    provider: 'self',
    property: 'globalCss',
    filter: function (css: string | null | undefined): boolean {
      return css !== undefined && css !== null && css.trim() !== '';
    }.toString(),
  },
  dynamicClasses: { provider: 'self', property: 'rootDynamicClasses' },
  style: {
    display: {
      provider: 'self',
      property: 'showPanel',
      startWith: {
        value: false,
      },
      transform: function (showPanel: boolean): 'none' | 'block' {
        return showPanel ? 'block' : 'none';
      }.toString(),
    },
  },
  dynamicVariables: {
    provider: 'id:root',
    property: 'rootCssVariables',
  },
};
